import { render, staticRenderFns } from "./planPro.vue?vue&type=template&id=11517c3c&scoped=true&"
import script from "./planPro.vue?vue&type=script&lang=js&"
export * from "./planPro.vue?vue&type=script&lang=js&"
import style0 from "./planPro.vue?vue&type=style&index=0&id=11517c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11517c3c",
  null
  
)

export default component.exports